import ApiBase from '../../ApiBase';

class Like extends ApiBase {
    route = '/cms/elements/likes';
}

export default new Like();
